<template>
  <base-form v-if="job"
             :title="job.status === 'active' ? $t('job.details.activation.pause.title') : $t('job.details.activation.activate.title')">
    <div class="overflow" v-if="job.status==='active'">
        <div class="overflow">
          {{$t('job.details.activation.pause.text')}}
        </div>
        <submit-button :loading="pauseLoading"
                     :disabled="job.status==='pause'"
                     @click="pauseOrActivateJob('pause')">
          {{$t('job.details.activation.pause.button')}}
        </submit-button>
    </div>
    <div class="overflow" v-else>
        <div class="overflow">
          {{$t('job.details.activation.activate.text')}}
        </div>
        <submit-button :loading="activateLoading"
                     :disabled="job.status==='active'"
                     @click="pauseOrActivateJob('active')">
          {{$t('job.details.activation.activate.button')}}
        </submit-button>
    </div>
  </base-form>
</template>
<script>
  import {Card} from 'src/components';
  import JobService from 'src/services/JobService';
  import { mapState } from 'vuex';
  export default {
    components: {
      Card
    },
    data() {
      return {
        activateLoading: false,
        pauseLoading: false
      }
    },
    computed: {
      ...mapState('jobs', {
        job: state => state.currentJob
      })
    },
    methods: {
      async pauseOrActivateJob(status = 'active') {
        try {
          this.loading = true;
          await JobService.setJobStatus(this.job.uuid, {
            status
          });
          let newJob = {
            ...this.job,
            status
          }
          this.updateStoreJob(newJob)
        } catch (e) {
          console.warn(e);
        } finally {
          this.loading = false;
        }
      },
      updateStoreJob (job) {
        this.$store.commit('jobs/SET_CURRENT_JOB', job)
      }
    }
  }
</script>
<style>
</style>
